export default __webpack_public_path__ + "static/media/ic_denmark.a6652bfd.svg";